<template>
    <form @submit.prevent="onSubmit">
        <div id="main" class="col-sms-6 col-sm-8 col-md-9">
            <div id="flight-features" class="tab-container">
                <ul class="tabs">
                    <li class="active">
                        <a href="#flight-details" data-toggle="tab">{{ tab_flightdetails[getCurrentLocale] }}</a>
                    </li>
                </ul>

                <div class="tab-content">
                    <div class="tab-pane fade in active" id="flight-details">
                        <!-- >>> 'BookingnoBookingDetails' - Outward Flight -->
                        <div v-if="getRebookingOriginalBookingHasOutwardFlight === true">
                            <h2>{{ tab_header_flightdetailsoutward[getCurrentLocale] }}:</h2>
                            <div v-for="(flight, index) in get_RebookingGetBookingResults.outwardFlights" v-bind:key="index">
                                <sdr-rebooking-bookingno-flightdetails :flight="flight" flightdirection="outward" :modulo="modulo" :mode="mode" whichcall="getbooking"></sdr-rebooking-bookingno-flightdetails>
                            </div>

                            <sdr-rebooking-bookingno-checkallpax flightdirection="outward" :modulo="modulo" v-if="mode ==='rebookingpassengers'"></sdr-rebooking-bookingno-checkallpax>
                        </div>
                        <!-- <<< 'BookingnoBookingDetails' - Outward Flight -->

                        <!-- >>> 'BookingnoBookingDetails' - Inbound Flight -->
                        <div v-if="getRebookingOriginalBookingHasReturnFlight === true">
                            <br /><hr style="border-top: 1px solid #fdb714;" /><br />
                            <h2>{{ tab_header_flightdetailsreturn[getCurrentLocale] }}:</h2>
                            <div v-for="(flight, index) in get_RebookingGetBookingResults.inboundFlights" v-bind:key="index">
                                <sdr-rebooking-bookingno-flightdetails :flight="flight" flightdirection="return" :modulo="modulo" :mode="mode" whichcall="getbooking"></sdr-rebooking-bookingno-flightdetails>
                            </div>

                            <sdr-rebooking-bookingno-checkallpax flightdirection="return" :modulo="modulo" v-if="mode ==='rebookingpassengers'"></sdr-rebooking-bookingno-checkallpax>
                        </div>
                        <!-- <<< 'BookingnoBookingDetails' - Inbound Flight -->
                    </div>
                </div>
            </div>


            <div v-if="mode ==='overview'">
                <br />
                <button type="submit" class="btn-large icon-check uppercase full-width sundairrebooking icon-check4" @click.prevent="onClick_Proceed_To_Passengers()" v-if="get_GotFlightsToRebook({ flightdirection: 'outward'}) === true || get_GotFlightsToRebook({ flightdirection: 'return'}) === true">{{ proceed[getCurrentLocale] }}</button>
                <a class="button btn-large uppercase full-width silver" style="margin-top:40px;" v-if="get_GotFlightsToRebook({ flightdirection: 'outward'}) === false && get_GotFlightsToRebook({ flightdirection: 'return'}) === false">{{ proceed[getCurrentLocale] }}</a>
            </div>

            <div v-if="mode ==='rebookingpassengers'">
                <br />
                <button type="submit" class="btn-large icon-check uppercase full-width sundairrebooking icon-check4" @click.prevent="onClick_Proceed_To_Flights()">{{ proceed2[getCurrentLocale] }}</button>
            </div>
        </div>
    </form>
</template>

<script>
    import FlightDetails from './BookingnoFlightDetails.vue';
    import CheckAllPax from './CheckAllPax.vue';

    import { mapGetters } from 'vuex';
    import { mapMutations } from 'vuex';
    import { mapActions } from 'vuex';

    import moment from 'moment';
    import { eventBus } from '../../../main';


    export default {

        /* >>> *************************************************************** / /* Props */
        props: ['modulo', 'mode'], // mode: 'overview', 'rebookingpassengers'
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Components */
        components: {

            'sdr-rebooking-bookingno-flightdetails': FlightDetails,
            'sdr-rebooking-bookingno-checkallpax': CheckAllPax,

        }, // eo components
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                // >>> --------------------------
                tab_header_flightdetailsoutward: {
                    en: 'Your flight and booking details for all outbound flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Hinflügen'
                },
                // >>> --------------------------
                tab_header_flightdetailsreturn: {
                    en: 'Your flight and booking details for all return flights',
                    de: 'Ihre Flug- und Buchungsdetails zu allen Rückflugen'
                },
                tab_flightdetails: {
                    en: 'Your booking overview',
                    de: 'Ihre Buchungsübersicht'
                },
                // >>> --------------------------
                proceed: {
                    en: 'PROCEED TO FLIGHT REBOOKING',
                    de: 'WEITER ZUR FLUGUMBUCHUNG',
                },
                // >>> --------------------------
                proceed2: {
                    en: 'PROCEED TO FLIGHT SELECTION',
                    de: 'WEITER ZUR FLUGAUSWAHL',
                },
                // >>> --------------------------
                departsAfter: null,
                returnsAfter: null,
                roundtrip: false,
                noOfAdultPassengers: 0,
                noOfAdultPaxOutward: 0,
                noOfAdultPaxReturn: 0,

                noOfChildPassengers: 0,
                noOfChildPaxOutward: 0,
                noOfChildPaxReturn: 0,

                noOfInfants: 0,
                noOfInfantsOutward: 0,
                noOfInfantsReturn: 0,

                idTicketOutwards: [],
                idTicketReturn: [],
                // >>> --------------------------
                nopaxselected: {
                    en: 'No Pax was selected.',
                    de: 'Kein Passagier ausgewählt.'
                },
                nopaxonoutwardflightwasselected: {
                    en: 'No Pax on Outward Flight was selected.',
                    de: 'Keinen Passagoier für den Hinflug ausgewählt.'
                },
                nopaxonreturnflightwasselected: {
                    en: 'No Pax on Return Flight was selected.',
                    de: 'Keinen Passagoier für den Rückflug ausgewählt.'
                },
                nonewoutwardflightdatewasselected: {
                    en: 'No new Outward Flight Date was selected.',
                    de: 'Kein neues Hinflug Datum ausgewählt.'
                },
                nonewreturnflightdatewasselected: {
                    en: 'No new Return Flight Date was selected.',
                    de: 'Kein neues Rückflug Datum ausgewählt.'
                },
            };

        }, // eo data
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
                'get_RebookingGetBookingResults',
                'getRebookingOriginalBookingHasOutwardFlight',
                'getRebookingOriginalBookingHasReturnFlight',
                'get_RebookingUsersSearchDataBookingno',
                'getRebookingOriginalBookingHasInfant',
                'get_GotFlightsToRebook',
            ]),

        }, // eo computed
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note: Catch Event 'readytoshowrebookingflightsearchresults' ('Call done ...').
        * Note:
        *
        */
		created: function () {

            let me = this;


            me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> created');
            if (this.mode ==='rebookingpassengers') {
                eventBus.$on('readytoshowrebookingflightsearchresults', this.onEmit_ReadyToShowRebookingFlightSearchResults);
            }

        }, // eo function created()

        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note:
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> beforeDestroy');
            if (this.mode ==='rebookingpassengers') {
                eventBus.$off('readytoshowrebookingflightsearchresults', this.onEmit_ReadyToShowRebookingFlightSearchResults);
            }
        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            ...mapActions([
                'actn_call_listFlightsForRebooking',
                'actn_setRebookingIdTickets',
            ]),


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_Proceed_To_Passengers()
            *
            * Desc:
            * Note:
            *
            */
            onClick_Proceed_To_Passengers: function(flight) {

                var me = this,
                    options = {};



                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> onClick_Proceed_To_Passengers');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };
                me.$router.push({ path: '/rebookingpassengers/' + me.modulo });
                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onClick_Proceed_To_Passengers()

            /*******************************************************************
            * onClick_Proceed_To_Flights()
            *
            * Desc:
            * Note:
            *
            */
            onClick_Proceed_To_Flights: function(flight) {

                var me = this,
                    valid = true,
                    tmp = null,
                    checkboxInputs = document.querySelectorAll('input[type=checkbox]:checked'),
                    arrayOfCheckboxesPaxes = [],
                    params = {};


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> onClick_Proceed_To_Flights');
                // >>> Reset Params ----------------------- 1.
                this.reset_LocalState();


                // >>> Catch Checkboxes ------------------- 2.
                for (var i = 0; i < checkboxInputs.length; i++) {
                    if (checkboxInputs[i].id.startsWith("single")) { // only single Paxes (checkboxes)
                        arrayOfCheckboxesPaxes.push(checkboxInputs[i].id);
                    }
                }


                // >>> Build Local State ------------------ 3a.
                this.build_LocalState_PaxCounts(arrayOfCheckboxesPaxes);
                // >>> Build Local State ------------------ 3b.
                this.build_LocalState_NewFlightDates();


                // >>> Checks ----------------------------- 4a.
                if (arrayOfCheckboxesPaxes.length === 0) { // no pax checked
                    me.$toasted.global.sdr_app_error({
                        message : this.nopaxselected[this.getCurrentLocale]
                    });
                    valid = false;
                }
                // >>> Checks ----------------------------- 4b.
                if (valid === true) {
                    if (this.departsAfter !== null && this.noOfAdultPaxOutward === 0 && this.noOfChildPaxOutward === 0 && this.noOfInfantsOutward === 0) { // no pax on outward
                        me.$toasted.global.sdr_app_error({
                            message : this.nopaxonoutwardflightwasselected[this.getCurrentLocale]
                        });
                        valid = false;
                    }
                }
                if (valid === true) {
                    if (this.returnsAfter !== null && this.noOfAdultPaxReturn === 0 && this.noOfChildPaxReturn === 0 && this.noOfInfantsReturn === 0) { // no pax on outward
                        me.$toasted.global.sdr_app_error({
                            message : this.nopaxonreturnflightwasselected[this.getCurrentLocale]
                        });
                        valid = false;
                    }
                }
                // >>> Checks ----------------------------- 4c.
                if (valid === true) {
                    if (this.departsAfter === null && (this.noOfAdultPaxOutward !== 0 || this.noOfChildPaxOutward !== 0 )) { // pax but no date on outward
                        me.$toasted.global.sdr_app_error({
                            message : this.nonewoutwardflightdatewasselected[this.getCurrentLocale]
                        });
                        valid = false;
                    }
                }
                if (valid === true) {
                    if (this.returnsAfter === null && (this.noOfAdultPaxReturn !== 0 || this.noOfChildPaxReturn !== 0 )) { // pax but no date on return
                        me.$toasted.global.sdr_app_error({
                            message : this.nonewreturnflightdatewasselected[this.getCurrentLocale]
                        });
                        valid = false;
                    }
                }
                // >>> Checks ----------------------------- 4d.


                // >>> Call ------------------------------- 5.
                if (valid === true) {
                    this.actn_setRebookingIdTickets({ idTicketOutwards: this.idTicketOutwards, idTicketReturn: this. idTicketReturn}) // save ticket ids for later

                    params = this.build_Params_Call_listFlightsForRebooking();
                    this.actn_call_listFlightsForRebooking(params);
                }

            }, // eo function onClick_Proceed_To_Flights()


            /******************************************************************* 'Listeners - eventBus'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onEmit_ReadyToShowRebookingFlightSearchResults()
            *
            * Desc: Handle
            * Note:
            *
            */
            onEmit_ReadyToShowRebookingFlightSearchResults: function() {

                let me = this,
                    options = {};


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> onEmit_ReadyToShowRebookingFlightSearchResults');
                // >>> Scroll Options ------------------------------------------
                options = {
                    container: 'body',
                    easing: 'linear',
                    offset: -60,
                    force: true,
                    cancelable: true,
                    onStart: function(element) {
                        // scrolling started
                    },
                    onDone: function(element) {
                        // scrolling is done
                    },
                    onCancel: function() {
                        // scrolling has been interrupted
                    },
                    x: false,
                    y: true
                };


                me.$router.push({ path: '/flightsearchresults/' + me.modulo });
                setTimeout(function() {
                    me.$scrollTo('#scrollPointTop', 200, options);
                }, 300);

            }, // eo function onEmit_ReadyToShowRebookingFlightSearchResults()




            /******************************************************************
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * build_Params_Call_listFlightsForRebooking()
            *
            * Desc: Build Object for Call.
            * Note:
            *
            */
            build_Params_Call_listFlightsForRebooking: function() {

                var me = this,
                    usersSearchData = this.get_RebookingUsersSearchDataBookingno,
                    params = {
                        identifier: {}
                    };


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> build_Params_Call_listFlightsForRebooking');
                params.departsAfter                 = this.departsAfter;
                params.departsBefore                = null;

                params.identifier.bookingCode       = usersSearchData.bookingCode;
                params.identifier.email             = usersSearchData.email;
                params.identifier.idInvoice         = usersSearchData.idInvoice;
                params.identifier.justIdInvoice     = usersSearchData.justIdInvoice;
                params.identifier.lastName          = usersSearchData.lastName;
                params.identifier.modify            = usersSearchData.modify;
                params.identifier.operatorBooking   = usersSearchData.operatorBooking;
                params.identifier.paxBirthDate      = usersSearchData.paxBirthDate;

                params.limit                        = 8;
                params.noOfAdultPassengers          = this.noOfAdultPassengers;
                params.noOfAdultPaxOutward          = this.noOfAdultPaxOutward;
                params.noOfAdultPaxReturn           = this.noOfAdultPaxReturn;
                params.noOfChildPassengers          = this.noOfChildPassengers;
                params.noOfChildPaxOutward          = this.noOfChildPaxOutward;
                params.noOfChildPaxReturn           = this.noOfChildPaxReturn;
                params.noOfInfants                  = this.noOfInfants;
                params.noOfInfantsOutward           = this.noOfInfantsOutward;
                params.noOfInfantsReturn            = this.noOfInfantsReturn;
                params.ojArprtCode                  = null;
                params.ojType                       = null;

                params.returnsAfter                 = this.returnsAfter;
                params.returnsBefore                = null;
                params.roundtrip                    = this.roundtrip;


                return params;

            }, // eo function build_Params_Call_listFlightsForRebooking()


            /*******************************************************************
            * build_LocalState_PaxCounts()
            *
            * Desc: Builds Pax Counts for Call 'rebookingflights'.
            * Note:
            *
            */
            build_LocalState_PaxCounts: function(arrayOfCheckboxesPaxes) {

                var me = this,
                    t = null,
                    tmp_noOfAdultPassengers = [],
                    tmp_noOfChildPassengers = [],
                    tmp_noOfInfants = [];


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> build_LocalState_PaxCounts');
                for (var i = 0; i < arrayOfCheckboxesPaxes.length; i++) {
                    var tmp = arrayOfCheckboxesPaxes[i].split('_');

                    if (tmp[3] === 'outward') {
                        if (tmp[4] === 'MR' || tmp[4] === 'MRS') {
                            this.noOfAdultPaxOutward = this.noOfAdultPaxOutward + 1;
                            tmp_noOfAdultPassengers.push(tmp[2]);
                            if (this.getRebookingOriginalBookingHasInfant({ idPax: tmp[2], idFlight: tmp[1] }) === true) {
                                this.noOfInfantsOutward = this.noOfInfantsOutward + 1;
                                tmp_noOfInfants.push(tmp[2]);
                            }
                        }

                        if (tmp[4] === 'CHD') {
                            this.noOfChildPaxOutward = this.noOfChildPaxOutward + 1;
                            tmp_noOfChildPassengers.push(tmp[2])
                        }

                        // Save TicketIds for later 'getRebookingKey'
                        this.idTicketOutwards.push(+tmp[5]);
                    }

                    if (tmp[3] === 'return') {
                        if (tmp[4] === 'MR' || tmp[4] === 'MRS') {
                            this.noOfAdultPaxReturn = this.noOfAdultPaxReturn + 1;
                            tmp_noOfAdultPassengers.push(tmp[2]);
                            if (this.getRebookingOriginalBookingHasInfant({ idPax: tmp[2], idFlight: tmp[1] }) === true) {
                                this.noOfInfantsReturn= this.noOfInfantsReturn + 1;
                                tmp_noOfInfants.push(tmp[2]);
                            }
                        }

                        if (tmp[4] === 'CHD') {
                            this.noOfChildPaxReturn = this.noOfChildPaxReturn + 1;
                            tmp_noOfChildPassengers.push(tmp[2])
                        }


                        // Save TicketIds for later 'getRebookingKey'
                        this.idTicketReturn.push(+tmp[5]);
                    }
                }

                // >>> Cummulate ----------------------------------------------
                t = tmp_noOfAdultPassengers.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]); // reduce for unique paxids
                this.noOfAdultPassengers = t.length;
                t = tmp_noOfChildPassengers.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
                this.noOfChildPassengers = t.length;
                t = tmp_noOfInfants.reduce(function(a,b){if(a.indexOf(b)<0)a.push(b);return a;},[]);
                this.noOfInfants = t.length;

            }, // eo function build_LocalState_PaxCounts()


            /*******************************************************************
            * build_LocalState_NewFlightDates()
            *
            * Desc: Builds New Flights Dates for Call 'rebokingflights'.
            * Note:
            *
            */
            build_LocalState_NewFlightDates: function(arrayOfCheckboxesPaxes) {

                var me = this,
                    newFlightDateOutward = document.getElementsByName("newDate_outward"),
                    newFlightDateReturn = document.getElementsByName("newDate_return"),
                    theActualTime = moment().format('HH:mm:ss'),
                    myDepPickerDate = null,
                    isToday = null,
                    date_from = null;


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> build_LocalState_NewFlightDates');
                // >>> Catch/build new Flight Dates ----------------------------
                if (newFlightDateOutward.length > 0) {
                    if (newFlightDateOutward[0].value !== '') {
                        date_from = newFlightDateOutward[0].value.split('.');
                        myDepPickerDate = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DD');
                        isToday = moment(String(myDepPickerDate)).isSame(moment().format('YYYY-MM-DD'));

                        if (isToday) {
                            this.departsAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT') + theActualTime;
                        }
                        if (!isToday) {
                            this.departsAfter = moment(date_from[2] + '-' + date_from[1] + '-' + date_from[0]).format('YYYY-MM-DDT00:00:ss+0000');
                        }
                    }
                }

                if (newFlightDateReturn.length > 0) {
                    if (newFlightDateReturn[0].value !== '') {
                        this.returnsAfter = newFlightDateReturn[0].value.split('.');
                        this.returnsAfter = moment(this.returnsAfter[2] + '-' + this.returnsAfter[1] + '-' + this.returnsAfter[0]).format('YYYY-MM-DDT00:00:ss+0000');
                    }
                }

                if (this.departsAfter !== null && this.returnsAfter !== null) {
                    this.roundtrip = true;
                } else {
                    this.roundtrip = false;
                }

            }, // eo function build_LocalState_NewFlightDates()


            /*******************************************************************
            * reset_LocalState()
            *
            * Desc: Reset 'Local State'.
            * Note:
            *
            */
            reset_LocalState: function() {

                var me = this;


                me.$toc('>>> rebooking/pagecontents/BookingnoBookingDetails.vue >>> reset_LocalState');
                this.departsAfter = null;
                this.returnsAfter = null;
                this.roundtrip = false;

                this.noOfAdultPassengers = 0;
                this.noOfAdultPaxOutward = 0;
                this.noOfAdultPaxReturn = 0;

                this.noOfChildPassengers = 0;
                this.noOfChildPaxOutward = 0;
                this.noOfChildPaxReturn = 0;

                this.noOfInfants = 0;
                this.noOfInfantsOutward = 0;
                this.noOfInfantsReturn = 0;

            }, // eo function reset_LocalState()

        }, // eo methods
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .tab-container ul.tabs li.active > a,
    .tab-container ul.tabs li:hover > a {
        color: #FDB714;
    }


    .icon-check4 {
        position: relative;
        padding-right: 30px !important;
        padding-left: 0 !important;
        overflow: hidden;
    }
    .icon-check4:after {
        content: '';
        position: absolute;
        top: 0;
        right: 10px;
        width: 30px;
        height: 100%;
        background: url(/res/images/icon/icon-check.png) no-repeat center center #FDB714;
    }
</style>
